import React, { useEffect, useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants,slide_bounce_variants,slide_bounce_down_variants} from "shared/components/animations";
import confirmBtn from "assets/images/och/confirm-btn.png";

const NewCardModal = ({ card, handleCloseModal = () => {}}) => {
  return (
      <motion.div variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"

       className="modal-overlay">
        <motion.div    variants={ slide_bounce_down_variants }  className="modal-bg">
          <h2>Your New Card!</h2>
          <div className="card-flex">
            {card?.map((item, key) => {
              return (
                <img
                  src={item?.url}
                  className={`img-fluid  patta${key + 1}`}
                  alt="your-card"
                />
              );
            })}
          </div>
          <img
            src={confirmBtn}
            onClick={() => handleCloseModal()}
            className="img-fluid"
            alt=""
          />
        </motion.div>
      </motion.div>
  );
};

export default NewCardModal;
